import router from 'src/router'
import {
    TweenLite
} from 'gsap'

class Arrow {

    constructor(config) {

        this.tweenObj = {
            alpha: 0,
            ambient_alpha: 1,
            y: 0
        };

        this.ctx = config.ctx;
        this.lineWidth = config.lineWidth;
        this.pixelRatio = config.pixelRatio;
        this.radius = config.radius;
        this.points = config.points;
        this.progress = config.progress;

        this.mousedown = false;
        this.ambient();
    }

    draw(progress) {
        this.ctx.save();
        this.ctx.translate(0, this.tweenObj.y);
        this.ctx.beginPath();
        this.ctx.strokeStyle = "#FFF";
        this.ctx.lineWidth = this.lineWidth * this.pixelRatio;
        this.ctx.moveTo(this.points.top.x - 10, this.points.top.y + 5);
        this.ctx.lineTo(this.points.top.x, this.points.top.y - 5);
        this.ctx.lineTo(this.points.top.x + 10, this.points.top.y + 5);
        this.ctx.globalAlpha = this.tweenObj.alpha * this.tweenObj.ambient_alpha;
        this.ctx.stroke();
        this.ctx.restore();
    }

    show() {
        TweenLite.to(this.tweenObj, 1, {
            alpha: 1
        });
    }

    hide() {
        TweenLite.to(this.tweenObj, 0.5, {
            alpha: 0
        });
    }

    ambient() {
        TweenLite.to(this.tweenObj, 0.5, {
            y: -20,
            delay: 3,
            ambient_alpha: 0,
            ease: 'Expo.easeIn',
            onComplete: () => {
                TweenLite.fromTo(this.tweenObj, 0.5, {
                    y: 30,
                    ambient_alpha: 0
                }, {
                    y: 0,
                    ambient_alpha: 1,
                    onComplete: this.ambient.bind(this)
                });
            }
        });
    }


    // input states

    up() {
        this.mousedown = false;
        this.ambient();
    }

    down() {
        this.mousedown = true;
        TweenLite.killTweensOf(this.tweenObj);
        TweenLite.set(this.tweenObj, {
            y: 0,
            ambient_alpha: 1
        });
    }

}

export default Arrow